import { DateTime } from 'luxon';
import { formatWithTimezoneChange } from '@library/utils/dateTime';

export const ERROR_MESSAGES = {
  INVALID_SHORT_DATE: ['Invalid MM/DD/YYYY format'],
  INVALID_EMAIL: ['Enter a valid email'],
  INVALID_HOUR: (contextValidations: boolean): Array<string> => [
    'Enter a valid hour (1-12)',
    contextValidations ? '' : 'Time will reset if you close this dialog'
  ],
  INVALID_MINUTE: (contextValidations: boolean): Array<string> => [
    'Enter a valid minute (00-59)',
    contextValidations ? '' : 'Time will reset if you close this dialog'
  ],
  INVALID_PASSWORD: ['Enter a valid password'],
  MAX_TIME: (maxDate: DateTime): Array<string> => [
    'This time is after the Max time allowed.',
    'Please select a new time.',
    'Max time:',
    formatWithTimezoneChange(maxDate, 'LL/dd/yyyy • t ZZZZ')
  ],
  MIN_TIME: (minDate: DateTime): Array<string> => [
    'This time is before the Min time allowed.',
    'Please select a new time.',
    'Min time:',
    formatWithTimezoneChange(minDate, 'LL/dd/yyyy • t ZZZZ')
  ],
  MULTIPLE_START_TIMES: (uniqueStartTimes: Array<string>): Array<string> => [
    'Multiple start times found for this game.',
    'Please select a start time.',
    'Times found:',
    ...uniqueStartTimes.map((time) => {
      return formatWithTimezoneChange(DateTime.fromISO(time), 'D * t ZZZZ');
    })
  ]
};
